<div class="flex items-center gap-2">
    <p-checkbox
        [name]="name"
        [binary]="binary"
        [disabled]="disabled"
        [ngModel]="value"
        (ngModelChange)="onModelChange($event)"
    />

    @if (label) {
        <label
            class="font-medium text-black cursor-pointer select-none"
            [class.opacity-50]="disabled"
        >
            {{ label }}
        </label>
    }
</div>
